import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss']
})
export class FeaturesComponent implements OnInit {

  constructor() { }

  @Input() testoiniziale: string;

  ngOnInit() {
    if (this.testoiniziale == null || this.testoiniziale == "") { this.testoiniziale = "A Cosa Sei Interessato?"; }
  }

}



// WEBPACK FOOTER //
// ./src/app/features/features.component.ts